import { render, staticRenderFns } from "./PortList.vue?vue&type=template&id=054221d2&scoped=true&"
import script from "./PortList.vue?vue&type=script&lang=js&"
export * from "./PortList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054221d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054221d2')) {
      api.createRecord('054221d2', component.options)
    } else {
      api.reload('054221d2', component.options)
    }
    module.hot.accept("./PortList.vue?vue&type=template&id=054221d2&scoped=true&", function () {
      api.rerender('054221d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/port/PortList.vue"
export default component.exports